import React from 'react';
import { motion } from 'framer-motion';

const Contact = () => {
  return (
    <section id="contact" className="py-20 lg:py-32 bg-white font-poppins">
      <div className="max-w-7xl mx-auto px-6">
        
        {/* Simple Modern Header */}
        <div className="mb-20 text-center lg:text-left">
          <div className="inline-block mb-4">
            <h2 className="text-3xl lg:text-5xl font-black text-slate-800 tracking-tight">
              Get in Touch
            </h2>
            <div className="w-16 h-1 bg-syana-blue-600 rounded-full mt-3 mx-auto lg:mx-0"></div>
          </div>
          <p className="text-slate-500 max-w-xl text-sm lg:text-base leading-relaxed font-medium mx-auto lg:mx-0">
            Reach out for any inquiries, clinical advice, or to book your next appointment at one of our premium branches.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-stretch">
          
          {/* Left Column: Simple Info Cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-1 gap-6">
            {[
              { icon: 'fa-location-dot', title: 'Corporate Office', value: 'No. 06, Ward Place, Colombo 07' },
              { icon: 'fa-phone', title: 'Telephone & Fax', value: '+94 11 75 75 100', sub: '+94 11 26 99 322 (Fax)' },
              { icon: 'fa-envelope', title: 'Email Support', value: 'info@siyaneoptom.lk' }
            ].map((item, i) => (
              <motion.div 
                key={i}
                initial={{ opacity: 0, y: 10 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
                className="p-6 lg:p-8 bg-slate-50 border border-slate-100 rounded-2xl flex items-center gap-6 hover:shadow-xl hover:shadow-slate-100 transition-all duration-500"
              >
                <div className="w-12 h-12 lg:w-14 lg:h-14 bg-syana-blue-600/10 rounded-xl flex items-center justify-center text-syana-blue-600 text-xl lg:text-2xl flex-shrink-0">
                  <i className={`fa-solid ${item.icon}`}></i>
                </div>
                <div>
                  <h4 className="text-[10px] font-black text-slate-400 uppercase tracking-widest mb-1">{item.title}</h4>
                  <p className="text-slate-900 font-bold text-sm lg:text-base">{item.value}</p>
                  {item.sub && <p className="text-slate-500 text-xs mt-0.5">{item.sub}</p>}
                </div>
              </motion.div>
            ))}
          </div>

          {/* Right Column: Clean Modern Form */}
          <motion.div 
            initial={{ opacity: 0, scale: 0.98 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="p-8 lg:p-12 bg-white border border-slate-100 rounded-2xl shadow-2xl shadow-slate-200/40 relative"
          >
            <form className="space-y-6 lg:space-y-8">
              <div className="grid md:grid-cols-2 gap-6 lg:gap-8">
                <div className="space-y-2">
                  <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest ml-1">Full Name</label>
                  <input 
                    type="text" 
                    className="w-full bg-slate-50 border border-slate-100 rounded-xl px-5 py-4 text-slate-900 placeholder:text-slate-400 focus:outline-none focus:border-syana-blue-600 transition-colors text-sm"
                    placeholder="Gimhani Nanayakkara"
                  />
                </div>
                <div className="space-y-2">
                  <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest ml-1">Email Address</label>
                  <input 
                    type="email" 
                    className="w-full bg-slate-50 border border-slate-100 rounded-xl px-5 py-4 text-slate-900 placeholder:text-slate-400 focus:outline-none focus:border-syana-blue-600 transition-colors text-sm"
                    placeholder="contact@example.com"
                  />
                </div>
              </div>

              <div className="space-y-2">
                <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest ml-1">Your Message</label>
                <textarea 
                  rows="4"
                  className="w-full bg-slate-50 border border-slate-100 rounded-xl px-5 py-4 text-slate-900 placeholder:text-slate-400 focus:outline-none focus:border-syana-blue-600 transition-colors resize-none text-sm"
                  placeholder="How can we help you today?"
                ></textarea>
              </div>

              <button className="w-full bg-syana-blue-600 hover:bg-slate-900 text-white rounded-xl py-4 lg:py-5 font-black uppercase text-xs tracking-[0.3em] transition-all shadow-xl shadow-syana-blue-600/20 active:scale-[0.98]">
                Send Message
              </button>
            </form>
          </motion.div>

        </div>
      </div>
    </section>
  );
};

export default Contact;
